<template>
  <v-card>
    <v-card-title>
      <span class="headline">Attachments</span>
    </v-card-title>
    <v-card-text>
      <template v-for="(type, k) in clmSub.types">
        <v-card :key="k">
          <v-expansion-panel v-if="type.subTypes && type.subTypes.length > 0" class="elevation-0">
            <v-expansion-panel-content v-for="(subType,j) in type.subTypes" :key="j">
              <div slot="header" class="v-input" v-if="subType.attachs && subType.attachs.length > 0">
                <v-icon>mdi-clipboard-text</v-icon>
                <span style="padding-left:5px">{{subType.desc}}</span>
              </div>
              <v-card-text v-if="subType.attachs && subType.attachs.length > 0">
                <template v-for="(subType, j) in type.subTypes">
                  <div :key="j">
                    <template v-for="(attach, i) in subType.attachs">
                      <div :key="i" @click="download(attach)">
                        <v-btn class="ma-2" color="primary" :loading="downloading">
                          <v-icon>mdi-download</v-icon> Download
                        </v-btn>
                        <span class="v-label" style="padding-left:10px;">{{attach.attachRefDesc}}</span>
                      </div>
                    </template>
                  </div>
                </template>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="secondary" @click="doClose">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { downloadPrompt } from '@/utils/file'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      downloading: false
    }
  },
  props: {
    clmSub: Object
  },
  methods: {
    async download(attach) {
      const apiURI = this.menu.downloadAttach
      this.downloading = true
      if (apiURI) {
        try {
          const expand = {
            appID: attach.appID,
            clmSubNo: attach.clmSubNo,
            clmType: attach.clmType,
            clmSubType: attach.clmSubType,
            attachRef: attach.attachRef
          }
          const result = await this.$http.get(expandURI(apiURI, expand), {
            responseType: 'blob'
          })
          var headers = result.headers
          var blob = new Blob([result.data], { type: headers['content-type'] })
          var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
          downloadPrompt(blob, filename)
        } catch (err) {
          const { data } = err.response
          if (data) {
            // As the request is requesting blob, error has to be formatted back to json
            try {
              const errUrl = URL.createObjectURL(data)
              const errRes = await this.$http.get(errUrl)
              URL.revokeObjectURL(errUrl)
              if (errRes.data) {
                this.notify(errRes.data)
              }
            } catch (err2) {
              console.log(err2)
            }
          }
        }
      } else {
        this.notify('Invalid API URL')
      }
      this.downloading = false
    },
    doClose() {
      this.$emit('doClose')
    }
  },
  computed: {
    menu() {
      return this.$store.state.claimStaging.menu
    },
    attachs() {
      if (this.clmSub.clmAttachStgs) {
        return this.clmSub.clmAttachStgs
      } else {
        return []
      }
    }
  }
}
</script>
